<template>
  <form
    class="find-user box is-centered"
    @submit.prevent="onSubmit"
  >
    <h1 class="title is-4 has-text-primary">
      Buscar Usuarios
    </h1>
    <div class="column is-12-mobile is-12-fullhd is-6">
      <AppInputField
        id="email"
        name="email"
        label="Email:"
        left-icon="email"
        placeholder="NO es necesario el email completo."
        :value="email"
        :disabled="isLoading"
        @input="onChange"
        @change="onChange"
      />
    </div>
    <div class="column is-12-mobile is-12-fullhd is-6">
      <AppInputField
        id="accountNumber"
        name="accountNumber"
        label="Número de cuenta:"
        left-icon="accountNumber"
        placeholder="Número de cuenta."
        :value="accountNumber"
        :disabled="isLoading"
        @input="onChangeCompany"
        @change="onChangeCompany"
      />
    </div>
    <ButtonSubmit
      :is-loading="isLoading"
      text="Buscar usuarios"
    />
  </form>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import upperFirst from 'lodash/upperFirst';
import AppInputField from '@/components/AppInputField.vue';

export default {
  name: 'FindUser',
  components: {
    AppInputField,
    ButtonSubmit: () => import(/* webpackChunkName: "auth-button-submit" */ '@/components/Auth/ButtonSubmit.vue'),
  },
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    ...mapState({
      email: state => state.users.email,
      accountNumber: state => state.users.company.accountNumber,
    }),
  },
  beforeMount() {
    this.setUserValue({ accessor: 'email', value: '' });
    this.setCompanyValue({ accessor: 'accountNumber', value: '' });
  },
  methods: {
    ...mapMutations({
      setUserValue: 'users/setValue',
      setCompanyValue: 'users/setCompanyValue',
    }),
    ...mapActions({
      getUsers: 'users/get',
    }),
    onChange(event) {
      const { name: accessor, value } = event.target;

      this.setUserValue({ accessor, value });
    },

    onChangeCompany(event) {
      const { name: accessor, value: plainValue } = event.target;

      const value = plainValue.split(' ').map(upperFirst).join(' ');

      this.setCompanyValue({ accessor, value });
    },
    async onSubmit() {
      if (this.email === '' && this.accountNumber === '') {
        this.$store.dispatch('addTemporalNotification', {
          type: 'danger',
          content: 'Necesitas llenar alguno de los campos.',
        });
      } else {
        this.isLoading = true;
        await this.getUsers({
          page: this.currentPage,
          size: this.size,
        });
        this.$emit('find');
        this.$router.push({ name: 'UsersList', query: { page: 1, size: 20 } });
      }
    },
  },
};
</script>

<style scoped>
form {
  flex-direction: column;
  margin: auto;
}

.submit-button {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

@media screen and (min-width: 769px) {
  form {
    max-width: 750px;
  }
}
.header-label {
  padding-right: 0.70rem;
}
</style>

<style lang="scss">
.find-user {
  .button.is-text,
  .button.is-text:hover,
  .button.is-text:focus {
    background: none;
    color: $primary;
  }
}
</style>
